import { render } from "./BaseRowHeader.vue?vue&type=template&id=661f43c3"
import script from "./BaseRowHeader.vue?vue&type=script&lang=js"
export * from "./BaseRowHeader.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__